<template>
  <div>
    <base-header class="pb-8 pt-4">
      <!-- Card stats -->
      <div class="row invoice-card-row">
        <div class="col-xl-6 col-xxl-6  col-sm-6  mt-2">
          <div class=" card bg-success invoice-card">
            <div class="card-body d-flex">
              <div class="icon mr-3">
                <i class="fas fa-chart-bar text-white mt-2"></i>
              </div>
              <div>
                <h2 class="text-white invoice-num">{{ formatCurrency(income) }} TL</h2>
                <span class="text-white fs-18">{{ $t('Toplam Gelir') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-xxl-6  col-sm-6 mt-2">
          <div class="card bg-info invoice-card">
            <div class="card-body d-flex">
              <div class="icon mr-3">
                <i class="fas fa-chart-pie text-white mt-2"></i>
              </div>
              <div>
                <h2 class="text-white invoice-num">{{ formatCurrency(expense) }} TL</h2>
                <span class="text-white fs-18">{{ $t('Toplam Gider') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-xxl-6  col-sm-6 mt-2">
          <div class="card bg-warning invoice-card">
            <div class="card-body d-flex">
              <div class="icon mr-3">
                <i class="ni ni-diamond text-white mt-2"></i>
              </div>
              <div>
                <h2 class="text-white invoice-num">{{ formatCurrency(income - expense) }} TL</h2>
                <span class="text-white fs-18">Net Kâr</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-xxl-6  col-sm-6 mt-2">
          <div class="card bg-success invoice-card">
            <div class="card-body d-flex">
              <div class="icon mr-3">
                <i class="fas fa-chart-bar text-white mt-2"></i>
              </div>
              <div>
                <h2 class="text-white invoice-num">{{ processes }}</h2>
                <span class="text-white fs-18">{{ $t('İşlem Sayısı') }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </base-header>


    <div class="container-fluid mt--7">
      <b-card no-body>
        <b-card-header>
          <div class="align-items-center row">
            <div class="col d-flex flex-column align-items-star">
              <h3 class="card-title mb-0">Kasa</h3>
              <div class="d-flex mt-2">
                <div class="text-sm" style="width:200px;">
                  <b-form-group class="mb-0">
                    <b-form-select v-model="filterType" :options="[
                      { text: 'Tüm Zamanlar', value: '' },
                      { text: 'Bugün', value: 'daily' },
                      { text: 'Bu hafta', value: 'weekly' },
                      { text: 'Bu ay', value: 'monthly' },
                      { text: 'Tarih seç', value: 'other' },
                    ]" />
                  </b-form-group>
                </div>
                <template v-if="filterType === 'other'">
                  <div class="text-sm ml-4" style="width:200px;">
                    <b-form-group class="mb-0">
                      <b-form-input type="date" v-model="startDate" />
                    </b-form-group>
                  </div>
                  <div class="text-sm ml-4" style="width:200px;">
                    <b-form-group class="mb-0">
                      <b-form-input type="date" v-model="endDate" />
                    </b-form-group>
                  </div>
                </template>
                <div class="text-sm ml-4" style="width:200px;">
                  <b-button variant="primary" @click="$refs.table.refresh()">{{ $t('Güncelle') }}</b-button>
                </div>
              </div>
            </div>
          </div>
        </b-card-header>
        <div class="table-container">
          <b-table ref="table" class="align-items-center" thead-class="thead-light" :fields="getFields" :items="items"
            show-empty>

            <template v-slot:empty>
              <div class="text-center">
                {{ $t('Henüz hiçbir kayıt bulunmamakta.') }}!
              </div>
            </template>
            <template v-slot:cell(sira)="data">
              <div class="text-center">
                {{ processes - data.index }}
              </div>
            </template>
            <template v-slot:cell(price)="data">
              <div class="text-center">
                {{ formatCurrency(data.item.price) }}
              </div>
            </template>
            <template v-slot:cell(date)="data">
              <div class="text-center">
                {{ moment(data.item.date).format('HH:mm DD-MM-YYYY') }}
              </div>
            </template>

            <template v-slot:table-busy>
              <div style="width: 100%; text-align:center;">
                <b-spinner label="Spinning"></b-spinner>
              </div>
            </template>

            <template v-slot:cell(title)="data">
              <b-badge variant="success" v-if="data.item.type === 'income'">{{ $t('GELİR') }}</b-badge>
              <b-badge variant="danger" v-else-if="data.item.type === 'expense'">{{ $t('GİDER') }}</b-badge>
            </template>

            <template v-slot:cell(payment_type)="data">
              <div v-if="data.item.payment_type === 'cash'">Nakit</div>
              <div v-else-if="data.item.payment_type === 'card'">Kart</div>
            </template>

            <template v-slot:cell(actions)="data">
              <b-button variant="warning" size="sm" v-if="getType != 'all'" @click="showAccounting(data.item)">{{
                $t('Görüntüle') }}</b-button>
              <b-button variant="danger" size="sm" v-if="getType != 'all'"
                @click="deleteAccountingAction(data.item.id)">Sil</b-button>
            </template>

          </b-table>

          <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3" v-if="pagination.totalRows > 9">
            <b-pagination @change="changepagination" v-model="pagination.currentPage" :total-rows="pagination.totalRows"
              :per-page="pagination.perPage" />
          </div>

        </div>
        <div class="w-full text-right p-3" v-if="getType != 'all'">
          <b-button variant="primary" @click="printData">{{ $t('Gün Sonu Al') }}</b-button>
          <!--          <b-button variant="info" @click="printDataExcel">{{ $t('Excel Rapor Al') }}</b-button> -->
        </div>
      </b-card>
    </div>
    <b-modal ref="accountingModal" :title="$t('İşlem Detayları')">
      <b-table :fields="[
        { key: 'sira', label: '' },
        { key: 'service.name', label: 'Ürün' },
        { key: 'price', label: 'Fiyat' }
      ]" :items="accounting_services" bordered>
        <template v-slot:cell(sira)="data">
          <div class="text-center">
            {{ data.index + 1 }}
          </div>
        </template>
        <template v-slot:cell(price)="data">
          <div class="">{{ formatCurrency(data.item.price) }} TL</div>
        </template>
      </b-table>
      <template v-slot:modal-footer>
        <b-button @click="$refs.accountingModal.hide()" variant="primary">{{ $t('Kapat') }}</b-button>
      </template>
    </b-modal>

    <b-modal ref="storageModal" :title="$t('İşlem Detayları')">
      <b-table :fields="[
        { key: 'category', label: 'Kategori' },
        { key: 'amount', label: 'Miktar' },
        { key: 'price', label: 'Fiyat' },
      ]" :items="accounting_services" bordered>
        <template v-slot:cell(sira)="data">
          <div class="text-center">
            {{ data.index + 1 }}
          </div>
        </template>
        <template v-slot:cell(price)="data">
          <div class="">{{ formatCurrency(data.item.price) }} TL</div>
        </template>
      </b-table>
      <template v-slot:modal-footer>
        <b-button @click="$refs.storageModal.hide()" variant="primary">{{ $t('Kapat') }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  computed: {
    ...mapGetters(['companies']),

    getFields() {
      let arr = [
        { key: 'title', label: 'Durum' },
        { key: 'price', label: 'Ücret' },
        { key: 'date', label: 'Tarih' },
        { key: 'payment_type', label: 'Ödeme Şekli' },
        { key: 'category', label: 'Kategori' },
      ];
      arr.push({ key: 'actions', label: '', tdClass: 'text-right' })
      return arr
    },
    getType() {
      return this.$route.params.type
    }
  },
  data() {
    return {
      company: null,
      // maxDate:moment().subtract(1, 'days').format('YYYY-MM-DD'),
      maxDate: moment().format('YYYY-MM-DD'),
      incometypes: [],
      inSafeMoney: null,
      accounting: {},
      income: '0',
      expense: '0',
      processes: '0',
      filterType: 'daily',
      startDate: '',
      endDate: '',
      pagination: {
        currentPage: 1,
        totalRows: 1,
        perPage: 10,
      },
      dailyCash: 0,
      records: [],
      accounting_services: [],
      // filterDay:moment().subtract(1, 'days').format('YYYY-MM-DD')
      filterDay: moment().format('YYYY-MM-DD')
    }
  },
  methods: {
    ...mapActions(['getSafe', 'deleteAccounting', 'printExcel', 'getAccountingServices']),
    moment,
    formatCurrency(value) {
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    printData() {
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      let items = '';
      this.records.forEach((item, index) => {
        items += `<tr>
                  <td>${this.processes - index}</td>
                  <td>${item.type == "income" ? "Gelir" : "Gider"}</td>
              <td>${this.formatCurrency(item.price)}</td>
                  <td>${this.moment(item.date).format('HH:mm DD-MM-YYYY')}</td>
                  <td>${item.payment_type == "cash" ? "Nakit" : "Kart"}</td>
          </tr>`;
      });
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
          </head>
          <body>
            <h1>Gün Sonu</h1>
            <pre><b>Rapor Tarihi : </b> ${moment().format('DD.MM.YYYY')}</pre>
            <pre><b>Gelir : </b> ${this.formatCurrency(this.income)}</pre>
            <pre><b>Gider : </b> ${this.formatCurrency(this.expense)}</pre>
            <pre><b>Kâr : </b> ${this.formatCurrency(this.income - this.expense)}</pre>
            ${this.incometypes.map(incometype => {
        return `<pre><b>${incometype.payment_type}</b>  : ${incometype.price}</pre>`
      }).join(" ")

        }
            <table style="width:100%" border="1">
              <thead>
                <tr>
                  <th style="text-align:left;"><b>İşlem</b></th>
                  <th style="text-align:left;"><b>Durum</b></th>
                  <th style="text-align:left;"><b>Ücret</b></th>
                  <th style="text-align:left;"><b>Tarih</b></th>
                  <th style="text-align:left;"><b>Ödeme Şekli</b></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                 ${items}
                </tr>
              </tbody>
            </table>
          </body>
        </html>`);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    deleteAccountingAction(id) {
      this.$swal({
        icon: 'warning',
        title: 'Dikkat',
        text: 'İşlem kalıcı olarak silinecektir, emin misiniz?',
      }).then(ok => {
        if (ok.value) {
          this.deleteAccounting(id).then(res => {
            this.success(res.data.message);
            this.refreshTable();
          }).catch(error => {
            this.error(error.response.data.message);
          });
        }
      });
    },
    showAccounting(data) {
      return this.getAccountingServices({ 'id': data.id, 'company': data.company_id }).then(data => data.data).then(response => {
        let $services = [];
        if (response.sale.length > 0) {
          $services = response.sale;
          this.$refs.accountingModal.show();
        } else {
          $services = [response.storage];
          this.$refs.storageModal.show();
        }
        this.accounting_services = $services;
        return this.accounting_services;
      }).catch(error => {
        this.error(error.response.data.message);
      })
    },
    refreshTable() {
      setTimeout(() => {
        this.$refs.table.refresh();
      }, 200);
    },
    changepagination(e) {
      this.$refs.table.refresh();
    },
    items() {
      const parameters = this.parameters();
      return this.getSafe(parameters).then(data => data.data).then(response => {
        this.income = response.income;
        this.expense = response.expense;
        this.processes = response.process_count;
        const records = response.records;
        this.records = records;

        this.pagination.totalRows = response.total;

        return records;
      }).catch(error => {
        this.error(error.response.data.message);
      })
    },
    parameters() {
      const params = {};
      params.type = this.filterType;

      if (params.type === 'other') {
        params.start_date = this.startDate;
        params.end_date = this.endDate;
      }

      params.page = this.pagination.currentPage;
      params.per_page = this.pagination.perPage;

      return params;
    }
  }
}
</script>

<style>
.table-container {
  overflow-x: auto;
  /* Taşma durumunda yatay kaydırma çubuğu ekler */
  max-width: 100%;
  /* Kapsayıcının maksimum genişliğini ayarlayın */
}

td div {
  text-align: center !important;
}

td {
  text-align: center !important;
}

tr {
  text-align: center !important;
}
</style>
